

//set defaults
export const DefaultMachineStatesBufferedParams = [
    { name: 'page', value: 0 },
    { name: 'pageSize', value: 20000 }
]


export const MachineStatus = {
    Working: 2,
    Warning: 1,
    Error: 0,
    Unknown: null
}